// import { FranchiseProvider } from "./FranchiseContext";
// import { FranchiseItemProvider } from "./FranchiseItemContext";
// import { CustomerProvider } from "./CustomerContext";
import { OutletProvider } from "./OutletContext";
// import { SparrowCreditProvider } from "./SparrowCreditContext";

const Providers = ({ children }) => {
  return <>
    <OutletProvider>

      {/* <FranchiseProvider>
        <FranchiseItemProvider> */}

      {/* <CustomerProvider>
        <SparrowCreditProvider> */}
      {children}
      {/* </SparrowCreditProvider>
      </CustomerProvider> */}

      {/* </FranchiseItemProvider>
      </FranchiseProvider> */}

    </OutletProvider>
  </>
};

export default Providers;
